import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.JobOffersView.heading',
    defaultMessage: 'Oferty pracy'
  },
  joinOurTeam: {
    id: 'views.JobOffersView.joinOurTeam',
    defaultMessage: 'DOŁĄCZ DO NASZEGO ZESPOŁU'
  },
  others: {
    id: 'views.JobOffersView.others',
    defaultMessage: 'POZOSTAŁE'
  },
  buttonQuestion: {
    id: 'views.JobOffersView.button.question',
    defaultMessage: 'NIE ZNALAZŁEŚ ODPOWIEDNIEGO STANOWISKA?'
  },
  buttonSendCV: {
    id: 'views.JobOffersView.button.sendCV',
    defaultMessage: 'WYŚLIJ CV MIMO TO!'
  }
});



// WEBPACK FOOTER //
// ./src/views/JobOffers/JobOffersView.intl.js